// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-2779e05a]{background-color:#f5f5f5;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
